import { render } from "./PasskeyVaultGate.vue?vue&type=template&id=0edf5f1f"
import script from "./PasskeyVaultGate.vue?vue&type=script&lang=js"
export * from "./PasskeyVaultGate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__